export default "__VITE_ASSET__quGx0HXP__"